<!-- @file 中奖名单组件 -->

<template>
  <div class="plv-lottery-list-default">
    <module-container
      ref="container"
      class="plv-lottery-list-default__container"
      :max-body-height="isGroup ? 380 : 265"
      @scroll="onScroll"
    >
      <!-- 分组 -->
      <template v-if="isGroup">
        <div v-if="groupList.length" class="plv-lottery-list-default__winner-list__group">
          <div
            v-for="(item, index) in groupList"
            :key="`group-${index}`"
            class="plv-lottery-list-default__winner-list__group__item"
            :class="{
              'plv-lottery-list-default__winner-list__group__item--active': item.id === currentGroupId
            }"
            @click="switchGroup(item)"
          >{{ item.title }}({{ item.count || 0 }})</div>
        </div>
        <ul
          class="plv-lottery-list-default__main__list"
        >
          <li v-for="(group, index) in winnerGroups" :key="index">
            <span v-for="(user, userIndex) in group" :key="userIndex">
              {{ user.viewerName }}
            </span>
          </li>
        </ul>
        <div
          v-if="!isLoading && winnerGroups.length === 0"
          class="plv-lottery-list-default__main__list__empty"
        >
          {{ iarTrans('lottery.groupEmpty') }}
        </div>
      </template>

      <!-- 非分组 -->
      <div v-else class="plv-lottery-list-default__main">
        <h3>{{ iarTrans('lottery.winnerList') }}</h3>
        <ul
          class="plv-lottery-list-default__main__list"
        >
          <li v-for="(group, index) in winnerGroups" :key="index">
            <span v-for="(user, userIndex) in group" :key="userIndex">
              {{ user.viewerName }}
            </span>
          </li>
        </ul>
      </div>
      <template #footer>
        <div class="plv-lottery-list-default__footer">
          <iar-button
            @click="onClickBack"
          >
            {{ iarTrans('lottery.back') }}
          </iar-button>
        </div>
      </template>
    </module-container>
  </div>
</template>

<script>
import mixin from './mixin';
import IarButton from '../../../components/common/button/PcButton';
import ModuleContainer from '../../common/module-container/PcModuleContainer';

export default {
  components: {
    IarButton,
    ModuleContainer,
  },

  mixins: [mixin],
};
</script>

<style lang="scss">
.plv-lottery-list-default {
  padding: 1px 0 0;
}

.plv-lottery-list-default__winner-list__group {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  background: #EDF1F7;
  height: 46px;
  flex-shrink: 0;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    cursor: pointer;
  }
  &::-webkit-scrollbar-thumb {
    background: #CFD8DC;
    border: 2px solid #EDF1F7;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-track-piece {
    background: #EDF1F7;
  }
}
.plv-lottery-list-default__winner-list__group__item {
  min-width: 100px;
  box-sizing: border-box;
  text-align: center;
  height: 46px;
  flex-shrink: 0;
  padding: 0 8px;
  line-height: 46px;
  color: #666666;
  font-size: 16px;
  cursor: pointer;
}
.plv-lottery-list-default__winner-list__group__item--active {
  color: #2296F3;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 30px;
    height: 2px;
    background: #2296F3;
  }
}

.plv-lottery-list-default__footer {
  padding: 24px 0 32px;
  text-align: center;
}

.plv-lottery-list-default__container {
  height: 100%;
}
.plv-lottery-list-default__main {
  padding: 24px 16px 0;
  h3 {
    height: 48px;
    margin: 0;
    padding: 0;
    background-color: #EDF1F7;
    text-align: center;
    color: #333333;
    font-size: 14px;
    font-weight: normal;
    line-height: 48px;
    border-bottom: 1px solid #ECEFF1;
  }
}
.plv-lottery-list-default__main__list {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    background: #ffffff;
    height: 48px;
    line-height: 48px;
    span {
      width: 33.3%;
      box-sizing: border-box;
      padding: 0 12px;
      display: inline-block;
      text-align: center;
      color: #546e7a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  li:nth-child(2n) {
    background: #F8F8FB;
  }
}

.plv-lottery-list-default__main__list__empty {
  font-size: 16px;
  color: #999;
  line-height: 334px;
  text-align: center;
}
</style>
